import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Couponsection } from 'src/app/model/couponsection.model';
import { CouponsectionService } from 'src/app/services/couponsection.service';
import { DateService } from 'src/app/services/date.service';
import { DatePipe } from '@angular/common';
import { RemovemodalcouponComponent } from 'src/app/modal/remove-modal-coupon/remove-modal-coupon.component';

@Component({
  standalone: false,
  selector: 'app-list-coupon',
  templateUrl: './list-coupon.component.html',
  styleUrls: ['./list-coupon.component.scss']
})
export class ListCouponComponent implements OnInit, OnDestroy {

  public couponsection = new Couponsection();
  private subscriptions = new Subscription();

  prakList: any = [];
  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  showDropdown: boolean = false;
  totalCount;
  displayCount;
  mainCouponList = [];
  newmainCouponList = [];
  couponsDeepCopy: any;
  newMainCoupons: any;
  couponsTempNew: any;
  masterSelectedCoupons: boolean;
  checkedCouponsList: any;
  checkedOnlyCouponsList: any;
  formatToDate: any;
  couponStartDate: any;
  couponEndDate: any;
  formatDate: any;
  selectedDate: any;
  selectedToDate: any;
  tempDate: any;
  selectedCouponName: any;
  mainCouponTypes = [];
  searchGroup: string = '';
  multiSelectGroup: any;
  searchCouponList = [];
  formattedSelectedDate: string = '';
  formattedSelectedToDate: string = '';
  fromDate: any;
  fDate: any;
  toDate: any;
  tDate: string;
  isDesc: boolean = false;
  column: string = 'couponValidFrom';
  searchCouponListDate = [];
  mainCouponLatestTypes = [];
  selectedCouponSortName: any;
  searchGroupSort: string = '';
  multiSelectGroupSort: any;
  onlyCouponIds = [];
  fromListPage = 'yes';
  toDateModified: any;
  newMonth: any;
  newDay: any;
  newMonthFrom: any;
  newDayFrom: any;
  fromDateModified: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private couponsectionService: CouponsectionService,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    public datepipe: DatePipe,
    private ngbCalendar: NgbCalendar,
  ) {
    localStorage.setItem('expandNavCreateview', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'Create and View',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(route);
  }

  ngOnInit(): void {
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;

    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    this.getTheCouponsList();
    this.getTheMainServiceGroupList();
    this.getTheLatestOldestFilter();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.couponsectionService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverSort(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openModal(onlyCouponIds: string, fromListPage: any): void {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalcouponComponent, modalOptions);
    modalRef.componentInstance.couponId = onlyCouponIds;
    modalRef.componentInstance.fromListPage = fromListPage;
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    this.newmainCouponList = this.mainCouponList.filter((item: { couponTitle: any }) => {
      return item.couponTitle.toLowerCase().includes(event.toLowerCase());
    });
    this.totalRows = this.newmainCouponList?.length;

    if (event == '') {
      //this.newmainCouponList = this.mainCouponList;
      if (this.multiSelectGroup == 'All' || this.multiSelectGroupSort == 'All') {
        this.newmainCouponList = this.mainCouponList;
      } else {
        if (this.searchCouponList.length > 0) {
          this.newmainCouponList = this.searchCouponList;
        } else if (this.searchCouponListDate.length > 0) {
          this.newmainCouponList = this.searchCouponListDate;
        } else {
          this.newmainCouponList = this.mainCouponList;
        }
      }
      this.totalRows = this.newmainCouponList?.length;
    }
  }

  handelCouponList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  goToCouponDetails(id) {
    this.router.navigate(['/coupon-details/' + id]);
  }

  checkUncheckAll() {
    for (var i = 0; i < this.mainCouponList.length; i++) {
      this.mainCouponList[i].isSelected = this.masterSelectedCoupons;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedCoupons);
    if (this.masterSelectedCoupons === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedCoupons = this.mainCouponList.every(function (item: any) {
      return item.isSelected === true;
    });
    console.log(this.masterSelectedCoupons);
    this.getCheckedItemList();
  }

  getCheckedItemList() {

    this.checkedCouponsList = [];
    this.checkedOnlyCouponsList = [];
    this.onlyCouponIds = [];

    for (var i = 0; i < this.mainCouponList?.length; i++) {

      if (this.mainCouponList[i].isSelected) {

        this.checkedCouponsList.push(this.mainCouponList[i]);
        this.checkedOnlyCouponsList.push(this.mainCouponList[i]);

        this.showDropdown = true;
      }
    }

    for (var j = 0; j < this.checkedOnlyCouponsList?.length; j++) {
      this.onlyCouponIds.push(this.checkedOnlyCouponsList[j].couponId);
    }

    console.log(this.onlyCouponIds);
    this.checkedCouponsList = JSON.stringify(this.checkedCouponsList);

  }


  getTheCouponsList() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.couponsectionService.getCouponList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainCouponList = res?.list;
        this.newmainCouponList = res?.list;
        this.newMainCoupons = res;
        this.couponsDeepCopy = JSON.parse(JSON.stringify(res));
        this.couponsTempNew = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.mainCouponList = [];
        this.newmainCouponList = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.mainCouponList?.length; i++) {
      this.mainCouponList[i].isSelected = false;
    }

    console.log(this.mainCouponList);

    this.getCheckedItemList();
  }

  // public updateSelectedDate(date: NgbDate) {
  //   console.log(date.month);
  //   this.couponStartDate = date.month + '/' + date.day + '/' + date.year;
  //   const jsDate = new Date(date.year, date.month - 1, date.day);
  //   this.selectedDate = this.convertFormat(date.year, date.month, date.day);
  //   this.formatDate = this.dateSrv.convertDateToLocaleString(
  //     date.day,
  //     date.month - 1,
  //     date.year
  //   );
  // }

  // public updateSelectedToDate(date: NgbDate) {
  //   this.couponEndDate = date.month + '/' + date.day + '/' + date.year;
  //   const jsDate = new Date(date.year, date.month - 1, date.day);
  //   this.selectedToDate = this.convertFormat(date.year, date.month, date.day);
  //   this.formatToDate = this.dateSrv.convertDateToLocaleString(
  //     date.day,
  //     date.month - 1,
  //     date.year
  //   );
  // }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  formatDateAll(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type

    }
  }

  getTheMainServiceGroupList() {

    this.mainCouponTypes.push({
      couponTypeId: null,
      couponTypeName: "Generic"
    },
      {
        couponTypeId: null,
        couponTypeName: "Brands"
      }
    );
    const allOpt = {
      couponTypeId: null,
      couponTypeName: "All"
    }
    this.mainCouponTypes.unshift(allOpt);
    this.selectedCouponName = this.mainCouponTypes[0].couponTypeName;
  }

  getTheLatestOldestFilter() {

    this.mainCouponLatestTypes.push({
      couponTypeIdSort: null,
      couponTypeNameSort: "Latest"
    },
      {
        couponTypeIdSort: null,
        couponTypeNameSort: "Oldest"
      }
    );
    const allOpt = {
      couponTypeIdSort: null,
      couponTypeNameSort: "All"
    }
    this.mainCouponLatestTypes.unshift(allOpt);
    this.selectedCouponSortName = this.mainCouponLatestTypes[0].couponTypeNameSort;
  }

  selectCouponType(item) {

    console.log(item);

    this.selectedCouponName = item.couponTypeName;

    if (item.couponTypeName !== null) {
      if (this.multiSelectGroup == item.couponTypeName) {
        this.multiSelectGroup.splice(this.multiSelectGroup.indexOf(item.couponTypeName), 1);
      } else {
        this.newMainCoupons.list = this.couponsDeepCopy.list;
        this.multiSelectGroup = item.couponTypeName;
      }
    }
    else {
      this.multiSelectGroup = 'All';
    }

    if (this.multiSelectGroup != '') {
      if (this.multiSelectGroup == 'All') {
        this.newmainCouponList = this.couponsDeepCopy.list;
      } else {
        if (this.searchCouponListDate.length > 0) {
          this.newmainCouponList = this.searchCouponListDate.filter((item) => {
            return item.couponType == this.multiSelectGroup;
          });
        } else {
          this.newmainCouponList = this.mainCouponList.filter((item) => {
            return item.couponType == this.multiSelectGroup;
          });
        }
      }
    } else {
      this.newmainCouponList = this.couponsDeepCopy.list;
    }

    this.searchCouponList = this.newmainCouponList;



    this.totalRows = this.newmainCouponList.length;
    this.totalCount = this.newmainCouponList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    if (this.multiSelectGroup != '') {
      this.selectedCouponName = this.mainCouponList.filter(group => group.couponType === this.multiSelectGroup)[0].couponType;
    } else {
      this.selectedCouponName = this.mainCouponList[0].couponType;
    }
  }

  selectCouponTypeSort(item) {

    console.log(item);

    this.selectedCouponSortName = item.couponTypeNameSort;

    if (item.couponTypeNameSort !== null) {
      if (this.multiSelectGroupSort == item.couponTypeNameSort) {
        this.multiSelectGroupSort.splice(this.multiSelectGroupSort.indexOf(item.couponTypeNameSort), 1);
      } else {
        this.newMainCoupons.list = this.couponsDeepCopy.list;
        this.multiSelectGroupSort = item.couponTypeNameSort;
      }
    }
    else {
      this.multiSelectGroupSort = 'All';
    }

    if (this.multiSelectGroupSort != '') {
      //this.selectedCouponSortName = this.mainCouponList.filter(group => group.couponType === this.multiSelectGroupSort)[0].couponType;
    } else {
      //this.selectedCouponSortName = this.mainCouponList[0].couponType;
    }

  }

  public async updateSelectedDate(date: NgbDate) {

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.fromDate = jsDate;

    this.newMonthFrom = date.month;
    if (date.month < 10) {
      this.newMonthFrom = '0' + date.month;
    }
    this.newDayFrom = date.day;
    if (date.day < 10) {
      this.newDayFrom = '0' + date.day;
    }
    this.fromDateModified = date.year + '-' + this.newMonthFrom + '-' + this.newDayFrom;

    this.toDateModified = this.toDateModified ? this.toDateModified : this.datepipe.transform(this.toDate, 'YYYY-MM-dd');
    console.log(this.toDateModified);
    console.log(this.fromDateModified);

    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'YYYY-MM-dd');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );

    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.newmainCouponList = this.mainCouponList.filter((item) => {
          return this.datepipe.transform(item.couponValidFrom, 'YYYY-MM-dd') >= this.fromDateModified && this.datepipe.transform(item.couponValidFrom, 'YYYY-MM-dd') <= this.toDateModified;
        });
        this.searchCouponListDate = this.newmainCouponList;
        this.totalRows = this.newmainCouponList.length;
        this.totalCount = this.newmainCouponList.length;
        this.displayCount = Math.ceil(this.totalCount / this.pageSize);
      } else {
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );

        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public async updateSelectedToDate(date: NgbDate) {

    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;

    this.newMonth = date.month;
    if (date.month < 10) {
      this.newMonth = '0' + date.month;
    }
    this.newDay = date.day;
    if (date.day < 10) {
      this.newDay = '0' + date.day;
    }
    this.toDateModified = date.year + '-' + this.newMonth + '-' + this.newDay;

    this.selectedToDate = this.datepipe.transform(jsDate, 'YYYY-MM-dd');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );

    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.newmainCouponList = this.mainCouponList.filter((item) => {
          return this.datepipe.transform(item.couponValidFrom, 'YYYY-MM-dd') >= this.datepipe.transform(this.fromDate, 'YYYY-MM-dd') && this.datepipe.transform(item.couponValidFrom, 'YYYY-MM-dd') <= this.toDateModified;
        });
        this.searchCouponListDate = this.newmainCouponList;
        this.totalRows = this.newmainCouponList.length;
        this.totalCount = this.newmainCouponList.length;
        this.displayCount = Math.ceil(this.totalCount / this.pageSize);
      } else {
        this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy')
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );
        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  sort(property: string, list: any[]) {
    this.isDesc = !this.isDesc; //change the direction
    this.column = property;
    let direction = this.isDesc ? 1 : -1;

    let sortedArray = list.sort(function (a, b) {
      if (a[property] > b[property]) {
        return -1 * direction;
      } else if (a[property] < b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
    return sortedArray;
  }

  goToBulkUploadPage() {
    this.router.navigate(['/bulk-upload-coupon/']);
  }

}
